import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { bookCatalog } from '../data/books';
import { solverBooks } from '../data/solverBooks';

export default function HomePage() {
  const solverBookIds = new Set(solverBooks.map((book) => book.id));
  const nonSolverBooks = bookCatalog.filter((book) => !solverBookIds.has(book.id));
  const collageBooks = [...nonSolverBooks].reverse().concat(solverBooks);
  const secondRowStart = nonSolverBooks.length;

  return (
    <>
      <Header />
      <main>
        <Link
          to="/books"
          aria-label="Browse Prism Puzzles books"
          className="group relative isolate block overflow-hidden bg-slate-950 text-white"
        >
          <div
            aria-hidden="true"
            className="absolute inset-0 grid auto-rows-fr grid-cols-4 gap-3 p-4 opacity-70 blur-[0.2px] transition duration-500 group-hover:scale-[1.02] sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-8"
          >
            {collageBooks.map((book, index) => (
              <div
                key={book.id}
                className={`min-h-0 overflow-hidden rounded-md border border-white/20 bg-white/10 shadow-2xl ${
                  index % 3 === 1 ? 'translate-y-8' : index % 3 === 2 ? '-translate-y-4' : ''
                } ${index === secondRowStart && solverBooks.length < 8 ? 'lg:col-start-2' : ''}`}
              >
                <img
                  src={book.coverUrl}
                  alt=""
                  className="h-full min-h-0 w-full object-cover"
                />
              </div>
            ))}
          </div>
          <div className="absolute inset-0 bg-[linear-gradient(90deg,_rgba(15,23,42,0.96)_0%,_rgba(15,23,42,0.78)_42%,_rgba(15,23,42,0.24)_100%)]" />
          <section className="relative mx-auto flex min-h-[68svh] max-w-6xl flex-col justify-end px-4 pb-14 pt-24 sm:px-6 md:pb-16">
            <p className="text-sm font-semibold uppercase tracking-[0.32em] text-brand-yellow">
              Logic puzzle books
            </p>
            <h1 className="mt-4 max-w-2xl text-5xl font-semibold leading-none text-white sm:text-6xl md:text-7xl">
              Prism Puzzles
            </h1>
            <p className="mt-5 max-w-xl text-base leading-7 text-slate-100 sm:text-lg">
              A wide variety of printed logic puzzle books. Browse available titles on Amazon,
              or try an online solver when you get stuck.
            </p>
            <span className="mt-7 inline-flex w-fit rounded-full bg-brand-cyan px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-cyan-950/30 transition group-hover:bg-brand-magenta">
              Browse books
            </span>
          </section>
        </Link>

        {/*
          Future homepage metric bubbles. Hidden for the first static launch.
        <section className="mx-auto grid max-w-6xl gap-4 px-4 py-8 sm:px-6 md:grid-cols-3">
          <div className="border-l-4 border-brand-cyan bg-white/75 px-5 py-4 shadow-sm">
            <p className="text-3xl font-semibold text-slate-900">{bookCatalog.length}</p>
            <p className="mt-1 text-sm font-medium text-slate-600">titles in the public book catalog</p>
          </div>
          <div className="border-l-4 border-brand-magenta bg-white/75 px-5 py-4 shadow-sm">
            <p className="text-3xl font-semibold text-slate-900">{solverBooks.length}</p>
            <p className="mt-1 text-sm font-medium text-slate-600">book-specific solver options</p>
          </div>
          <div className="border-l-4 border-brand-lime bg-white/75 px-5 py-4 shadow-sm">
            <p className="text-3xl font-semibold text-slate-900">{collageBooks.length}</p>
            <p className="mt-1 text-sm font-medium text-slate-600">covers in the homepage collage</p>
          </div>
        </section>
        */}
      </main>
    </>
  );
}
